/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  Cart,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    CartFromJSON,
    CartToJSON,
} from '../models';

export interface RemoveVoucherRequest {
    xApplicationScope: ApplicationScope;
}

/**
 * 
 */
export class CartControllerApi extends runtime.BaseAPI {

    /**
     * remove voucher from current cart
     * remove voucher from current cart
     */
    async removeVoucherRaw(requestParameters: RemoveVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling removeVoucher.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/carts/current/vouchers`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * remove voucher from current cart
     * remove voucher from current cart
     */
    async removeVoucher(requestParameters: RemoveVoucherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.removeVoucherRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
